import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, role, blockAdmin }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-stone-500" data-testid="loading-screen">
        Loading…
      </div>
    );
  }
  if (!user) {
    // Preserve where the user was trying to go so they're returned after login.
    const next = location.pathname + (location.search || "");
    // If the visitor was heading to a provider-onboarding path, pre-select
    // the provider signup flow on the auth screen — otherwise a companion
    // sees a generic Customer login and gets confused.
    const isProviderPath = location.pathname.startsWith("/become-provider");
    const roleQS = isProviderPath ? "&role=provider" : "";
    return <Navigate to={`/auth?next=${encodeURIComponent(next)}${roleQS}`} replace />;
  }
  if (role === "admin" && user.role !== "admin") return <Navigate to="/discovery" replace />;
  // Marketplace pages (profile/bookings/become-provider/subscription) are
  // hidden for admin accounts — they have no place there.
  if (blockAdmin && user.role === "admin") return <Navigate to="/admin" replace />;
  return children;
}
